/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { GetVideoHlsPlaylistOptions, GetVideoHlsPlaylistResponses } from '../../models/GetVideoHlsPlaylist'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @description Get HLS playlist URL.
 * @summary Get Hls Playlist
 * {@link /video/:video_id/hls-playlist}
 */
export function getVideoHlsPlaylist<ThrowOnError extends boolean = true>(options: Options<GetVideoHlsPlaylistOptions, ThrowOnError>): Promise<UnwrappedResult<GetVideoHlsPlaylistResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'GET', url: '/video/{video_id}/hls-playlist', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<GetVideoHlsPlaylistResponses, ThrowOnError>>
}
